import type { SVGProps } from 'react';
import type { PaymentMethod } from '../../types/payment';

type IconProps = SVGProps<SVGSVGElement>;

function PixIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 2l4 4-4 4-4-4 4-4z" />
      <path d="M12 14l4 4-4 4-4-4 4-4z" />
      <path d="M2 12l4-4 4 4-4 4-4-4z" />
      <path d="M14 12l4-4 4 4-4 4-4-4z" />
    </svg>
  );
}

function CardIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <rect x="3" y="6" width="18" height="13" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="7" y1="15" x2="9" y2="15" />
    </svg>
  );
}

function PointsIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v3" />
      <path d="M12 19v3" />
      <path d="M2 12h3" />
      <path d="M19 12h3" />
      <path d="M5 5l2 2" />
      <path d="M17 17l2 2" />
      <path d="M5 19l2-2" />
      <path d="M17 7l2-2" />
    </svg>
  );
}

function MilesIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M21 13l-9 4-9-4 9-9 9 9z" />
      <path d="M12 17v4" />
      <path d="M9 21h6" />
    </svg>
  );
}

function CryptoIcon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" {...props}>
      <path d="M12 2l8 6-8 8-8-8 8-6z" />
      <path d="M12 16v6" />
      <path d="M8 10l4 2 4-2" />
    </svg>
  );
}

const ICON_MAP: Record<PaymentMethod, (p: IconProps) => JSX.Element> = {
  pix: PixIcon,
  card: CardIcon,
  points: PointsIcon,
  miles: MilesIcon,
  crypto: CryptoIcon,
};

type PaymentMethodIconProps = IconProps & {
  name: PaymentMethod;
};

export function PaymentMethodIcon({ name, ...rest }: PaymentMethodIconProps) {
  const Icon = ICON_MAP[name];
  return <Icon {...rest} />;
}
